import script from "./NavMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavMenu.vue?vue&type=script&setup=true&lang=ts"

import "./NavMenu.vue?vue&type=style&index=0&id=ef1c5250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef1c5250"]])

export default __exports__